import React from 'react';
import { useNavigate } from 'react-router-dom';

function Shell({ code, emoji, title, message, color }) {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit', padding: 24 }}>
      <div style={{ background: 'white', borderRadius: 12, padding: 48, maxWidth: 480, textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
        <div style={{ fontSize: 64, fontWeight: 900, color, lineHeight: 1 }}>{code}</div>
        <div style={{ fontSize: 40, margin: '12px 0' }}>{emoji}</div>
        <h2 style={{ margin: '0 0 8px', color: '#1a1a2e', fontSize: 22 }}>{title}</h2>
        <p style={{ margin: '0 0 24px', color: '#888', fontSize: 14, lineHeight: 1.5 }}>{message}</p>
        <button onClick={() => navigate('/dashboard')} style={{ padding: '10px 24px', background: '#3B3A8F', color: 'white', border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>Back to Dashboard</button>
      </div>
    </div>
  );
}

export function NotFound() {
  return <Shell code="404" emoji="🧭" title="Page Not Found" message="The page you're looking for doesn't exist or has been moved." color="#3B3A8F" />;
}

export function Forbidden() {
  return <Shell code="403" emoji="🔒" title="Access Denied" message="You don't have permission to view this page. Contact your administrator if you believe this is a mistake." color="#E22D2D" />;
}
